namespace advisorop.components.advisor {

    export class SubAccountListController {

        // bindings
        public subAccounts: domains.IAccount[];
        public $router;

        public dgSubAccountOptions: DevExpress.ui.dxDataGridOptions;

        static $inject = ["advisorService", "identityService", "generalService"];

        constructor(private advisorService: services.AdvisorService,
            private generalService: services.GeneralService,
            private ids: services.IdentityService) {

            this.dgSubAccountOptions = {
                export: {
                    enabled: false,
                    fileName: `SubAccounts`
                },
                bindingOptions: {
                    dataSource: `vm.subAccounts`
                },
                scrolling: {
                    mode: `standard`,
                    useNative: true
                },
                //height: `350px`,
                paging: { pageSize: 20 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,

                noDataText: `No SubAccounts Found`,
                stateStoring: {
                    enabled: true,
                    type: `localStorage`,
                    storageKey: `dgSubAccountOptions`
                },
                columnChooser: {
                    enabled: false,
                    title: `Select columns`
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: 'Search...'
                },                
                columns: [
                    { dataField: "name", caption: "Account Title", width: 160, cellTemplate: "colFullName" },
                    { dataField: "number", caption: "Account Number" },
                    { dataField: "accountTypeDescription", caption: "Account Type" },
                    { dataField: "advisoryFirm.advisoryFirmName", caption: "Advisory Firm" },
                    { dataField: "proposalAdvisoryFee", caption: "Advisory Fee", cellTemplate: "advisoryFeeTemplate" },
                    { dataField: "proposalAdvisorFeeBillingDescription", caption: "Billing Type", width: 90 },
                    { dataField: "proposalAdvancedBillingStyle", caption: "Billing Style", width: 90 },
                    { dataField: "proposalAmount", caption: "Proposal Investment", format: { type: "currency", precision: 2 } },
                    { dataField: "dateCreated", caption: "Created", dataType: "date", format: "shortDate" },
                    { dataField: "statusDescription", caption: "Status" },
                ],
                onContextMenuPreparing: (e: any) => {
                    e.items = [];
                    if (e.rowIndex > -1) { // context menu does not work for detail rows in master-detail
                        if (e.row.rowType == "data") {
                            let managed = e.row.data.advisoryFirmMgtRole == domains.AdvisoryFirmMgtRole.MANAGED;
                            let hasProposal = (e.row.data.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS
                                || e.row.data.accountType == domains.InvestmentType.MANAGED_MODELS
                                || e.row.data.accountType == domains.InvestmentType.SMA);

                            // account-summary.html tab numbers are below for reference.
                            // it does not look like uib - tab supports index names as strings so we are using numbers.
                            //Tab 0: "General Information"
                            //Tab 2: "Outside Holdings"
                            //Tab 3: "Proposals"
                            //Tab 4: "Households and Groups"
                            //Tab 5: "Audit Account"
                            //Tab 6: "Edit Details"
                            //Tab 7: "Documentation"

                            e.items.push({ text: "Account Summary", onItemClick: () => this.onContextMenuItemClick(e, "AccountSummary", 0) });
                            if (e.row.data.status != domains.AccountStatus.SETUP) {
                                if (hasProposal) {
                                    e.items.push({ text: "Proposals", onItemClick: () => this.onContextMenuItemClick(e, "AccountSummary", 3) });
                                    if (e.row.data.accountType == domains.InvestmentType.INDIVIDUAL_HOLDINGS) {
                                        e.items.push({ text: "Change to Managed Models Account", onItemClick: () => this.onContextMenuItemClick(e, "AccountSummary", 6) })
                                    } else {
                                        e.items.push({ text: "Change to Individual Holdings Account", onItemClick: () => this.onContextMenuItemClick(e, "AccountSummary", 6) })
                                    }
                                }
                            }
                            e.items.push({ text: "Documentation", onItemClick: () => this.onContextMenuItemClick(e, "AccountSummary", 7) });
                        }
                    }
                },
            };
        }

        onContextMenuItemClick(e: any, menuitem: string, navTabParam?: number) {
            let data = e.row.data;

            // navigation tab parameter - index of initial tab in next window (optional)
            let ntp = (navTabParam != null) ? navTabParam : 0;
            if (menuitem === "AccountSummary") {
                this.$router.navigate(["AccountSummary", { accountId: data.id, NP: ntp}]);

            }
        };

        $onChanges(evt) {
            //console.log("Anyhting?");
        };
        
        $onInit(): void {
        }
        
    }
    
    class SubAccountList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                subAccounts: "<",
                $router: "<"
            };
            this.controller = [`advisorService`, `generalService`, `identityService`, SubAccountListController];
            this.controllerAs = `vm`;
            this.templateUrl = `spa/advisor-module/components/sub-account-list.html`;
        }
    }
    angular.module(Constants.APP).component(`subAccountList`, new SubAccountList());

}